import axios from 'axios';

export const fetchTaskRemote = (taskId) => {
    return axios.get(`/fhir/Task?_id=${taskId}`);
};
